/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\Email\EmailService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 28th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 3rd June 2024 10:38:25
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { FromRefTime, buildAxiosHeader, buildURL } from "Utils/Request.utils";
import Axios from "axios";

type TipimailBodyType = {
    from?: string,
    to?: string,
    userEmail?: string,
    tag?: string[],
    content?: string,
};

export default class EmailService {
    static async getAll(body: TipimailBodyType) {
        if (body.from ) {
            body.from = FromRefTime(body.from);
        }
        let myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.TIPIMAIL}`;
        const response = await Axios.post(myUrl, body , buildAxiosHeader());
        return response.data;
    }

    static async CallDataNameStatsEmail(data: string[], key: string) {
        const myURL = buildURL({ids: data, key: key}, `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.TIPIMAIL}/data`);
        if (!myURL)
            throw new Error(`Unable to build URL from: ${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.TIPIMAIL}/data and ${JSON.stringify({ids: data, key: key})}`)
        const response = await Axios.get(myURL, buildAxiosHeader());
        return response.data;
    }
}
